module.exports = __webpack_public_path__ + "franchise-13.png?207de82b77426a55b8929f672da0e92b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/franchise-13.png
// module id = 280
// module chunks = 0